/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OrganizationInputs */

const en_organization = /** @type {(inputs: OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const nl_organization = /** @type {(inputs: OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisatie`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {OrganizationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const organization = /** @type {((inputs?: OrganizationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OrganizationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_organization(inputs)
	return en_organization(inputs)
});